

import React from "react";
import { i18nManager } from "../i18n";
import loader from "../assets/images/loading_circle.gif";

export interface LoadingProps {
    label?: string;
    loaderAlt?: string;
}

function Loading(props: LoadingProps) {

    const labels = i18nManager.Labels.loading;

    return (<div className="loading">
        <img src={loader} alt={props.loaderAlt ?? labels.loader_alt} />
        {props.label && (<span>{props.label}</span>)}
    </div>);

}

export default Loading;
